

<header class="masthead" style="background-color:#1cd5db;">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-10 mx-auto" style="font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;">
                <div class="site-heading" style="padding: 28px 0;">

                </div>
            </div>
        </div>
    </div>
</header><br><br><br>
<div class="row">
    <div class="col-4 offset-md-4  text-center">
        <h2>Resend Email Confirmation</h2>
    </div>
</div>
<br>
<div class="row">
    <div class="col-2 offset-md-5  text-center">
        <form #form="ngForm" (ngSubmit)="onSubmit()">
            <input type="email" name="email" #email="ngModel" 
            [(ngModel)]="model.email"
            placeholder="Please enter your email" class="form-control">
            <br>
            <button type="submit" class="btn btn-primary form-control">
                Resend Confirmation Email
            </button>
        </form>
    </div>
</div>
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
